import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { TriwordStore } from '../../TriwordStore';
import { useAnimationOnTrigger, usePrevious } from '../../../shared/utils';

type InputSquareProps = {
  position: number;
};

const InputSquare = ({ position }: InputSquareProps) => {
  const { guess, revealed, solved, solution, wrongGuess, usedLetterLifeline }
    = TriwordStore.useState();

  const guessLetter: string | undefined = guess[position];
  const previousGuessLetter = usePrevious(guessLetter);

  const hasNewLetter = !!guessLetter && !previousGuessLetter;
  const showNewLetterAnimation = useAnimationOnTrigger(hasNewLetter, 100);

  const classes = `inputSquare` +
   `${showNewLetterAnimation ? ' newLetter': ''}` +
   `${solved ? ' solved' : ''}` +
   `${wrongGuess ? ' wrongGuess' : ''}`;

  const showLock = !solved && !revealed && (usedLetterLifeline && (position === solution.length - 1));

  const showSolutionLetter = revealed || solved || (usedLetterLifeline && (position === solution.length - 1));

  return (
    <div className={classes}>
      {(showSolutionLetter) ? solution[position] : guessLetter || ''}
      {showLock && <div className="revealedLetterLock"><LockIcon/></div>}
    </div>
  );
};

export default InputSquare;